import { SET_MESSAGES } from "./types";
import { Message } from "refsix-js-models";

export const setMessages = (messages: Message[]) => {
    return {
        type: SET_MESSAGES,
        messages,
    };
};
